<template>
  <div class="home">
    <Navbar :is-active="5"></Navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/UsuariosB2B" class="tab">
            <div class="tab__icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2B</p>
            </div>
          </router-link>
          <router-link to="/UsuariosB2C" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2C</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Usuarios B2C</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Código de cliente" v-model="code" @keyup="search">
          <input type="text" placeholder="DNI" v-model="dni" @keyup="search">
          <input type="text" placeholder="Nombres" v-model="user_name" @keyup="search">
          <input type="text" placeholder="Apellidos" v-model="user_lastname" @keyup="search">
          <input type="text" placeholder="Email" v-model="email" @keyup="search">
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>

        </div>
        <div class="page__buttons">
          <ButtonExport
            :data="branchoffice"
            :columns="columns"
            :sheet-name="'Datos Socio Comercial'"
            :file-name="'Reporte Socio Comercial'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p>Código de cliente</p>
            <p>Nombres</p>
            <p>Apellidos</p>
            <p>Correo electronico</p>
            <p>Celular</p>
            <p>Fecha nacimiento</p>
            <p>Token</p>
            <p>Estado</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="branch of branchoffice" v-bind:key="branch.id">
              <p>{{ codeFormat(branch.code) }}</p>
              <p>{{ branch.user_name }}</p>
              <p>{{ branch.user_lastname}}</p>
              <p :data-descr="branch.email" >{{ branch.email}}</p>
              <p>{{ branch.cellphone}}</p>
              <p>{{ branch.birthday_date}}</p>
              <p>{{ (branch.is_token === 1) ? 'Activo' : 'Inactivo'}}</p>
              <p>{{ (branch.user_status === 1) ? 'Activo' : 'Desactivado'}}</p>
              <div class="dropdown" >
               <button class="button" @click="show('id-dropdown-content'+branch.id)">
                 <i class="fa fa-ellipsis" style="color: red"></i>
               </button>
               <div @mouseleave="show('id-dropdown-content'+branch.id)" class="dropdown-content" :id="'id-dropdown-content'+branch.id">
                <button class="dropdown-item" @click="showAlertUsuariosB2C(branch.id)">
                  <i class="fas fa-bars " ></i> Restablecer contraseña
                </button>
               </div>
              </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Dropdown from '@/components/Dropdown.vue'
import Pagination from '@/components/Pagination.vue';
import OpenArrow from '@/components/OpenArrow.vue';
import HiddenArrow from '@/components/HiddenArrow.vue';
import ButtonExport from '@/components/ButtonExport.vue'
import {conditionalFormatValue} from '@/utils/formats'
import { codeFormat } from '@/utils/formats'
import $ from 'jquery'
import Navbar from '@/components/NavBar'

export default {
  name: 'UsuariosB2C',
  components: {
    Dropdown,
    Pagination,
    OpenArrow,
    HiddenArrow,
    ButtonExport,
    Navbar
  },
  data() {
    return {
      branchoffice:[],
      type: 'UsuariosB2C',
      id:'',
      user_name:'',
      pagination: [],
      user_lastname:'',
      email:'',
      usuario: '',
      fecha: '',
      columns: [
        { 
          label: 'Código Cliente', 
          field: 'code' 
        },
        { 
          label: 'Nombres', 
          field: 'user_name' 
        },
        {
          label: 'Apellidos',
          field: 'user_lastname',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Celular',
          field: 'cellphone',
        },
        {
          label: 'Fecha de Nacimiento',
          field: 'birthday_date',
        },
        {
          label: 'Token',
          field: 'is_token',
          dataFormat: value => this.conditionalFormatValue(value, 'Activo', 'Inactivo')
        },
        {
          label: 'Estado',
          field: 'user_status',
          dataFormat: value => this.conditionalFormatValue(value, 'Sí', 'No')
        }
      ]
    }
  },
  created() {
    this.getall();
    this.getDate();
    this.usuario = localStorage.getItem('usuario');

  },
  computed:{
    incidenceData:  function () {
      let temp = [];
      let result =  axios
          .get("general/incidence")
          .then(res => {
            res.data.data.forEach(item =>{
              axios.get("general/client/"+ item.user_id).then(resUser => {
                item.nameUser= resUser.data.data.client_name;
                item.lastname= resUser.data.data.client_lastname;
                item.cellphone= resUser.data.data.client_cellphone;
                temp.push(item);
              })
              return temp;
            })
          })

    }
  },
  methods:{
    codeFormat,
    async showAlertUsuariosB2C(id){
        const { value: confirmButtonText } = await this.$swal.fire({
          title: 'Restablecer contraseña',
          icon: 'warning',
          text: 'Está por Restablecer contraseña de este usuario, ¿Desea confirmar la acción?',
          confirmButtonText: 'Restablecer contraseña',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showCloseButton: true
        })
        if (confirmButtonText === true){
          await axios.put("general/users/reset-password/"+id).then((response) => {
            this.$swal.fire({
              title: 'Reseteo de password realizado',
              icon: 'success',
              showCloseButton: true
            })
          }).catch((error) => {
            this.$swal.fire({
              title: 'No se pudo resetear el password ',
              icon: 'error',
              showCloseButton: true
            })
              })
        }
      },
    show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
    },
    clean_filter(){
      this.code = '';
      this.dni = '';
      this.user_name = '';
      this.user_lastname = '';
      this.email = '';
      this.getall();
    },
    conditionalFormatValue,
    zeroFill(number, width) {
        width -= number.toString().length
        if (width > 0) {
          return (
              new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
          )
        }
        return number + ''
      },
    getDate() {
        let dias = [
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
          'Domingo'
        ]
        let meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ]

        let date = new Date()

        const fechaNum = date.getDate()
        const mes_name = date.getMonth()

        let day = date.getDay() === 0 ? 6 : date.getDay() - 1
        this.fecha = dias[day] + ' ' + this.zeroFill(fechaNum, 2) + ' de ' + meses[mes_name]
      },
    search: function() {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        let paramSearch = {
          code: self.code,
          user_name: self.user_name,
          user_lastname: self.user_lastname,
          email: self.email,
          dni: self.dni,
        }
        this.getall(1, paramSearch)
      }.bind(this), 500);
    },
    handleClickInParent: function(page) {
      this.getall(page)
    },
    changePage(url) {
      this.$router.push(url)
    },
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    addBranchOffice(){
      this.$router.push('/addbranchoffice')
    },
    async getall(page = 1, paramSearch = {}) {
      await axios.get('user',{
        params: {
          page: page,
          code: ( typeof paramSearch.code === 'undefined' || paramSearch.code === '' ) ? null : parseInt(paramSearch.code),
          user_name: paramSearch.user_name,
          user_lastname: paramSearch.user_lastname,
          email: paramSearch.email,
          user_doc_number: paramSearch.dni,
        },
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }}).then( res => {
        if (res.data.data.total > 0){
          this.branchoffice = res.data.data.data
          this.pagination = res.data.data
          this.empty = false
        }else{
          this.branchoffice = {}
          this.pagination = {}
          this.empty = true
        }
      })
    },
  }
}


</script>

<style scoped>
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}

/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 200px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
}
.home .navbar__right .profile {
  display: flex;
  width: 300px;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;

}
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}
.page__title{
  display: flex;
  gap: .5rem;
}
.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}
.page__title .floating-icon{
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}
.page__title h2{
  margin-top: 6px;
}
.body__sidebar.open{
  display: none;
}
.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}

.body__containt {
  height: fit-content;
  min-height: 87vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
}

.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
}

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}
.body__containt .page__filters input {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background: #fff;
  padding: 15px 20px;
  /* margin: 0 10px; */
}

.body__containt .page__buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.body__containt .page__buttons .button {
  width: 250px;
  padding: 15px 20px;
  border-radius: 15px;
  font-size: 17px;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body__containt .page__buttons .button:nth-child(1) {
  background: #32ba7c;
}
.body__containt .page__buttons .button:nth-child(2) {
  background: #ff3128;
}
.body__containt .page__buttons .button:nth-child(3) {
  background: #262626;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
  padding: 2px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
/* .body__containt .page__filters input:nth-child(1) {
  width: 300px;
  margin: 0;
  margin-right: 10px;
} */


/*------BODY------*/

.body__sidebar.open{
  display: none;
}
/* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
  }
  .page__filters select{
    padding: 10px 19px;
    width: 54% !important;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;
  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{
    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 20px;
    margin-top: -18px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }
}


</style>
